export const environment = {
  production: true,
  groupName: "Fitness-For-Service-Level1-Web-User-Access",
  envName: 'PROD'
};
